<!--MODAL HEADER-->
<div class="modal-header">
  <h4 class="modal-title" translate>
    <span *ngIf="create" translate>CREATE_NEW </span>
    <span translate>RETURN_WARRANTY</span> {{ data?.id }}
  </h4>
  <div>
    <div *ngIf="!create && (isAdmin || isSales)" ngbDropdown placement="bottom-right"
      class="d-inline-block dropup mt-3 ml-auto">
      <button class="btn btn-outline-primary export-area-buttons" id="dropdownBasic1" ngbDropdownToggle translate>
        ACTIONS
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-container">
        <button class="export-area-buttons" ngbDropdownItem *ngFor="let button of actions | async"
          (click)="button.performAction(null)" translate>
          {{ button.label }}
        </button>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

</div>
<!--MODAL BODY-->
@if (searchMode) {
<div class="modal-body" *ngIf="isLoaded; else loading">
  <form [formGroup]="submitForm">
    <fieldset class="bg-light p-1 m-2">
      <div class="row">
        <div class="col-5">
          <lib-gung-input-dropdown-filter gungTranslate="CUSTOMER" formControlName="customerId" [renderStatic]="isUser"
            [formatter]="formatterCustomer" [formatterView]="formatterViewCustomer" [list]="customerList">
          </lib-gung-input-dropdown-filter>
        </div>
      </div>
      <div class="row">
        <div class="col-5" formGroupName="extra">
          <lib-gung-text-input formControlName="productId" gungTranslate="PRODUCT_ID"></lib-gung-text-input>
        </div>
        <div class="col-2 pt-3 d-flex align-items-center justify-content-center">
          <span translate>OR</span>

        </div>
        <div class="col-5" formGroupName="extra">
          <label for="serialNumber">
            <span translate>Q_ARTSERIENR</span>
            @if (serialNrIsRequired) {
            <span class="text-danger">*</span>
            }
          </label>
          <lib-gung-text-input formControlName="serialNumber" suppressLabel="true"
            [required]="serialNrIsRequired"></lib-gung-text-input>
        </div>
      </div>
    </fieldset>
  </form>
</div>
<!--MODAL FOOTER-->
<div class="modal-footer">
  <div class="row">
    <div class="col-12 pr-4 d-flex justify-content-end">
      <button *ngIf="!isUser || create" type="button" class="btn btn-primary" (click)="searchRows()"
        translate>SEARCH_ROWS</button>
    </div>
  </div>
</div>
} @else {
<div class="modal-body" *ngIf="isLoaded; else loading">
  <form [formGroup]="submitForm">
    <fieldset [disabled]="!editHeader && !create" class="bg-light p-1 m-2">
      <div class="row">
        <div class="col-4">
          <label for="CUSTOMER">
            <span translate>CUSTOMER</span>
            @if (isCustomerRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          @if (isAdmin) {
          <lib-gung-input-dropdown-filter class="mt-0" formControlName="customerId" suppressLabel="true"
            [renderStatic]="isUser || (!editHeader && !create)" [formatter]="formatterCustomer"
            [formatterView]="formatterViewCustomer" [required]="isSaveButtonDisabled" [list]="customerList"
            (ngModelChange)="newDataAdded = true;">
          </lib-gung-input-dropdown-filter>
          } @else {
          <lib-gung-text-input formControlName="customerId" suppressLabel="true" (ngModelChange)="newDataAdded = true;"
            [renderStatic]="(!editHeader && !create)" [required]="isSaveButtonDisabled"></lib-gung-text-input>
          }
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="productId">
            <span translate>PRODUCT_ID</span>
            @if (isProductIdRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-text-input formControlName="productId" suppressLabel="true" [required]="isSaveButtonDisabled"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="serialNumber">
            <span translate>Q_ARTSERIENR</span>
            @if (serialNrIsRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-text-input formControlName="serialNumber" suppressLabel="true"
            (ngModelChange)="newDataAdded = true;" [renderStatic]="(!editHeader && !create)"
            [required]="serialNrIsRequired"></lib-gung-text-input>
        </div>
        @if (!create) {
        <div class="col-4">
          <span style="font-size: x-small" translate>STATUS</span><br />
          <span>{{ submitForm.get('status').value | translate }}</span>
        </div>
        }
        <div class="col-4">
          <label for="DATE_CREATED">
            <span translate>DATE_CREATED</span>
            @if (isDateRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-date-picker [minInitialDate]="today" [currentselectedDate]="submitForm.get('date').value"
            (selectedDate)="submitForm.get('date').setValue($event); newDataAdded = true;"
            [extraInputClass]="'form-control-sm'" extraBtnClass="btn-sm" [renderStatic]="(!editHeader && !create) || create" [disabled]="(!editHeader && !create) || create"
            suppressLabel="true"></lib-gung-date-picker>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="CAUSE_OF_RETURN">
            <span translate>CAUSE_OF_RETURN</span>
            @if (isReturnCauseRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-meta-data-select-input suppressLabel="true" metaId="kundreklamationorsak" table="orkk"
            metaDisplay="kundreklamationbeskr" [showId]="false" class="gung-select-input-sm-NOT-USE"
            formControlName="returnCause" [required]="isSaveButtonDisabled" [renderStatic]="(!editHeader && !create)"
            hideEmptyOption="true" (ngModelChange)="newDataAdded = true;"></lib-meta-data-select-input>
        </div>
        @if (isAdmin) {
          <div class="col-4" formGroupName="extra">
            <lib-gung-input-multi-select [optionsList]="userOptions"
              (selectedValues)="setSelectedUser($event); newDataAdded = true;" [singleSelection]="true"
              [required]="isSaveButtonDisabled" label="SEND_EMAIL_TO_USER"
              [renderStatic]="(!editHeader && !create)"></lib-gung-input-multi-select>
          </div>
        } @else {
          <div class="col-4" formGroupName="extra">
            <label for="SEND_EMAIL_TO_USER">
              <span translate>SEND_EMAIL_TO_USER</span>
            </label>
            <lib-gung-text-input formControlName="sendAttestTo" suppressLabel="true"
              [renderStatic]="true"></lib-gung-text-input>
          </div>
        }

        @if (!create) {
        <div class="col-4">
          <span style="font-size: x-small" translate>RMA_NR</span><br />
          <span>{{submitForm.get('extra')?.get('rmaNr')?.value}}</span>
        </div>
        }
        <div class="col-4">
          <span style="font-size: x-small" translate>ORDER_ID</span>
          @if (isOrderIdRequired) {
            <span class="text-danger"> *{{ 'REQUIRED' | translate}} - {{ 'AUTOMATICALLY_ADDED_WHEN_ROW_IS_SELECTED' | translate}}</span>
          }
          <br />
          <span>{{submitForm.get('orderId')?.value}}</span>
        </div>
      </div>
    </fieldset>
    <fieldset [disabled]="!editHeader && !create" class="bg-light p-1 m-2">
      <div class="row">
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="endCustomerName" gungTranslate="END_CUSTOMER_NAME"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="COAddress" gungTranslate="CO_ADDRESS"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="phoneNo" gungTranslate="PHONE_NUMBER"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="endCustomerEmail" gungTranslate="END_CUSTOMER_EMAIL"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="endCustomerAddress" gungTranslate="END_CUSTOMER_ADDRESS"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="zipcode" gungTranslate="ZIP_CODE"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="city" gungTranslate="CITY" [renderStatic]="(!editHeader && !create)"
            (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="COUNTRY">
            <span translate>COUNTRY</span>
          </label>
          <lib-meta-data-select-input suppressLabel="true" metaId="landskod" table="xr" metaDisplay="land"
            [showId]="false" class="gung-select-input-sm-NOT-USE" formControlName="country"
            [renderStatic]="(!editHeader && !create)" hideEmptyOption="true"
            (ngModelChange)="newDataAdded = true;"></lib-meta-data-select-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="dateOfSale">
            <span translate>DATE_OF_SALE</span>
            @if (isDateOfSaleRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-date-picker [currentselectedDate]="submitForm.get('extra.dateOfSale').value"
            (selectedDate)="submitForm.get('extra.dateOfSale').setValue($event); newDataAdded = true;"
            suppressLabel="true"></lib-gung-date-picker>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="dateFaultOccurred">
            <span translate>DATE_FAULT_OCCURRED</span>
            @if (isDateFaultOccurredRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-date-picker [currentselectedDate]="submitForm.get('extra.dateFaultOccurred').value"
            (selectedDate)="submitForm.get('extra.dateFaultOccurred').setValue($event); newDataAdded = true;"
            suppressLabel="true"></lib-gung-date-picker>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="typeOfUse">
            <span translate>TYPE_OF_USE</span>
            @if (isTypeOfUseRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-select-option-input
            suppressLabel="true"
            [required]="true"
            formControlName="typeOfUse"
            [optionsList]="typeOfUseOptions"
            [showId]="false"
            [renderStatic]="(!editHeader && !create)"
            (ngModelChange)="newDataAdded = true;">
          </lib-gung-select-option-input>
        </div>
      </div>
    </fieldset>
    <fieldset class="bg-light p-1 m-2">
      <div class="row">
        <div class="col-8">
          <label for="ERROR_DESCRIPTION">
            <span translate>ERROR_DESCRIPTION</span>
            @if (isCommentRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-text-area-input formControlName="comment" (ngModelChange)="newDataAdded = true;"
            gungTranslate="ERROR_DESCRIPTION" suppressLabel="true"></lib-gung-text-area-input>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label class="w-100" for="file-upload" translate>ATTACH_FILES</label>
            <lib-gung-input-file accept="image/*" [multiple]="multipleFiles"
              (onFileSelect)="onFileSelect($event); newDataAdded = true;"></lib-gung-input-file>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4" formGroupName="extra">
          <lib-gung-text-input formControlName="claimNoCounterPart" gungTranslate="CLAIM_NO_COUNTER_PART"
            [renderStatic]="(!editHeader && !create)" (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
      </div>
    </fieldset>
    @if (!create) {
    <div class="row">
      <div class="col-12 mx-2">
        <lib-gung-accordion>
          <lib-gung-accordion-item [collapsed]="false">
            <ng-template libGungAccordionHeader>{{'SHOW_MORE_COMMENTS' | translate}}</ng-template>
            <ng-template libGungAccordionBody>
              <ng-container *ngTemplateOutlet="comments; context: { $implicit: data?.comments}"></ng-container>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div>
    </div>
    <ng-template #comments let-comments let-index="index">
      <div class="comments bg-light m-2 p-1">
        <div class="row" *ngFor="let comment of comments"
          [class.justify-content-end]="currentUser.username === comment.user">
          <div class="col-10 rounded m-2"
            [ngClass]="{ 'bg-gainsboro': currentUser.username !== comment.user, 'bg-light-green': currentUser.username === comment.user }">
            <div class="row">
              <div class="col-6 text-left">
                {{ comment.user }}
              </div>
              <div class="col-6 text-right">
                {{ comment.date | date : dateUtilService.dateFormat }}
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ comment.comment }}
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <ng-container *ngFor="let attachment of comment.attachments">
                  <div class="d-block">
                    <a *ngIf="attachment?.includes('/'); else oldDocument" [title]="attachment.split('/').pop()"
                      [href]="attachment | gungDownloadUrl" class="mx-2 text-dark border-0">
                      {{ attachment.split('/').pop() }}
                      <i class="fa-solid fa-cloud-arrow-down fa-1x"></i>
                    </a>
                    <ng-template #oldDocument>
                      <a (click)="downloadFile(attachment)" class="mx-2 text-dark border-0">
                        <i class="fas fa-download fa-1x"></i>
                      </a>
                    </ng-template>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    }
    @if (orderRowsAreEmpty) {
    <div class="alert alert-danger m-2" role="alert" translate>
      NO_ORDER_ROWS_FOUND
    </div>
    }
    @if (submitForm.get('status').value === "APPROVED" && (isSales || isAdmin)) {
    <fieldset class="bg-light p-1 m-2">
      <div class="row">
        <div class="col-4" formGroupName="extra">
          <label for="CLAIM_WORKFLOW">
            <span translate>CLAIM_WORKFLOW</span>
            @if (isClaimWorkflowRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-meta-data-select-input suppressLabel="true" metaId="claimworkflow" table="claimworkflow"
            metaDisplay="claimworkflowdescr" [showId]="false" class="gung-select-input-sm-NOT-USE"
            formControlName="claimWorkflow" hideEmptyOption="true" [required]="isClaimWorkflowRequired"
            [optionsFilterFunctionTableRecord]="claimWorkflowFilterFunction"></lib-meta-data-select-input>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="RETURN_SUB_CAUSE">
            <span translate>RETURN_SUB_CAUSE</span>
            @if (isReturnSubCauseRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
          <lib-gung-input-multi-select [optionsList]="customerWarrantySubReason"
            (selectedValues)="setCustomerWarrantySubReason($event); newDataAdded = true;" [singleSelection]="true"
            [required]="isReturnSubCauseRequired"
            [renderStatic]="(!editHeader && !create)"
            [previewField]="'name'"></lib-gung-input-multi-select>
        </div>
        <div class="col-4" formGroupName="extra">
          <label for="RETURN_CAUSE_GROUP">
            <span translate>RETURN_CAUSE_GROUP</span>
            @if (isReturnCauseGroupRequired) {
            <span class="text-danger"> *</span>
            <span class="text-danger" translate>REQUIRED</span>
            }
          </label>
            <lib-gung-text-input formControlName="returnCauseGroup" suppressLabel="true" [required]="isReturnCauseGroupRequired"
            (ngModelChange)="newDataAdded = true;"></lib-gung-text-input>
        </div>
      </div>
    </fieldset>
    }
    <!-- END header -->
    @if (create && !orderRowsAreEmpty) {
    <div class="row">
      <div class="col-12">
        <h2 translate>ORDER_ROWS</h2>
        <div class="table-responsive gung-responsive return-row-table">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col" translate>PRODUCT_ID</th>
                <th scope="col" translate>QUANTITY</th>
                <th scope="col" width="100px" translate>Q_ARTSERIENR</th>
                <th scope="col" translate><span translate>ORDER_ID</span></th>
                <th scope="col" translate>OH_KUNDBESTNR</th>
                <th scope="col" translate>ROW_NR</th>
                <th scope="col" translate>DATE</th>
                <th scope="col" translate>ATTACH_FILES</th>
              </tr>
            </thead>
            <tbody formArrayName="rows">
              <tr *ngFor="let row of rows.controls; let i = index" [formGroupName]="i">
                <td [attr.data-label]="'SELECTED_ROW' | translate" formGroupName="extra">
                  <div>
                    @if (row.get('extra.selected')?.value) {
                      <button type="button" class="btn btn-success" (click)="onRowSelectionChange(i)"
                      translate>SELECTED_ROW</button>
                    } @else {
                    <button type="button" class="btn btn-primary" (click)="onRowSelectionChange(i)"
                      translate>SELECT_ROW</button>
                    }
                  </div>
                </td>
                <td [attr.data-label]="'PRODUCT_ID' | translate">
                  <span>{{row.get('id')?.value}}</span>
                  <lib-forms-message-error [controller]="row.get('id')"></lib-forms-message-error>
                </td>

                <td [attr.data-label]="'QUANTITY' | translate">
                  <span>{{row.get('quantity')?.value}}</span>
                </td>

                <td [attr.data-label]="'Q_ARTSERIENR' | translate">
                  <span>{{row.get('extra.serialNumber')?.value}}</span>
                </td>

                <td [attr.data-label]="'ORDER_ID' | translate">
                  <span>{{row.get('note')?.value}}</span>
                </td>

                <td [attr.data-label]="'OH_KUNDBESTNR' | translate">
                  <span>{{row.get('extra.kundbestnr')?.value}}</span>
                </td>

                <td [attr.data-label]="'ROW_NR' | translate">
                  <span>{{row.get('extra.rownr')?.value}}</span>
                </td>

                <td [attr.data-label]="'DATE' | translate">
                  <span>{{row.get('date')?.value.toISOString().substring(0, 10)}}</span>
                </td>

                <td [attr.data-label]="'ATTACH_FILES' | translate">
                  <div formArrayName="attachments">
                    <div *ngFor="let attachment of row.getRawValue().attachments; let indexAttachment = index">
                      <span *ngIf="attachment && !attachment.name" class="d-block">
                        <a *ngIf="attachment?.includes('/'); else oldDocument" [title]="attachment.split('/').pop()"
                          [href]="attachment | gungDownloadUrl" class="mx-2 text-dark border-0">
                          {{ attachment.split('/').pop() }}
                          <i class="fa-solid fa-cloud-arrow-down fa-1x"></i>
                        </a>
                        <button *ngIf="!isUser || create" (click)="removeAttachement(i, indexAttachment)" type="button"
                          class="btn btn-sm btn-danger">
                          <i class="fa-solid fa-trash-can"></i>
                        </button>
                        <ng-template #oldDocument>
                          <a (click)="downloadFile(attachment)" class="mx-2 text-dark border-0">
                            <i class="fas fa-download fa-1x"></i>
                          </a>
                        </ng-template>
                      </span>
                    </div>
                  </div>

                  <lib-gung-input-file accept="image/*" [multiple]="true"
                    (onFileSelect)="onFileSelect($event, i)"></lib-gung-input-file>
                  <lib-forms-message-error [controller]="row.get('attachments')"></lib-forms-message-error>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <lib-forms-message-error [controller]="submitForm.get('rows')"></lib-forms-message-error>
      </div>
    </div>
    }
    <div formGroupName="extra">
      @if (termsCheckboxShown) {
      <fieldset>
        <div class="row">
          <div>
            <input class="mr-2" type="checkbox" formControlName="approveTerms" id="terms" />
            <label class="fs-6" for="terms" translate>ACCEPT_TERMS</label>
          </div>
        </div>
      </fieldset>
      }
    </div>
  </form>
</div>
<!--MODAL FOOTER-->
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close('Cancel click')" translate>CANCEL</button>
  @if (isSaved) {
    <button type="button" class="btn btn-primary" [disabled]="true" (click)="onSave()"
      translate>
      SAVED
    </button>
  } @else {
    <button type="button" class="btn btn-primary" [disabled]="disabled || isSaveButtonDisabled" (click)="onSave()"
      translate>
      SAVE
    </button>
  }
</div>
}

<ng-template #loading> LOADING... </ng-template>
